export const config = {
    apiUrl: process.env.NODE_ENV === 'production'
        ? 'https://revarmy-backend.couriers.workers.dev'
        : 'https://revarmy-backend.couriers.workers.dev',
    appName: 'RevArmy',
    version: '2.0.0',
};
  